import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from "react-bootstrap";
import { compose, pure, withHandlers, withState } from "recompose";

import Checkbox from "../../elements/CustomCheckbox/CustomCheckbox.jsx";
import CustomRadio from "../../elements/CustomRadio/CustomRadio";
import { FormattedMessage } from "react-intl";
import NumberFormat from "react-number-format";
import React from "react";
import { SaveButton } from "../../elements/ActionButtons/SaveButton";
import SideModal from "../../elements/Modal/SideModal";
import Switch from "react-bootstrap-switch";
import TaxLabelInput from "./TaxLabelInput";
import _ from "lodash";

const label = withState("label", "setLabel", ({ tax }) => {
  return tax.label;
});

const mode = withState("mode", "setMode", ({ tax }) => {
  return tax.mode;
});

// const codeDeclarationVente = withState("codeDeclarationVente", "setCodeDeclarationVente", ({ tax }) => {
//   console.log("25 - tax=", tax);
//   return tax.codeDeclarationVente;
// });

// const codeDeclarationAchat = withState("codeDeclarationAchat", "setCodeDeclarationAchat", ({ tax }) => {
//   return tax.codeDeclarationAchat;
// });

// const codeDeclarationImmo = withState("codeDeclarationImmo", "setCodeDeclarationImmo", ({ tax }) => {
//   return tax.codeDeclarationImmo;
// });

const pourcentValue = withState(
  "pourcentValue",
  "setPourcentValue",
  ({ tax }) => {
    return tax.pourcentValue;
  }
);

const id = withState("id", "setId", ({ tax }) => {
  return tax.id;
});

const defaultTaxCheck = withState(
  "defaultTaxCheck",
  "setDefaultTaxCheck",
  ({ tax }) => {
    return tax.defaultTaxCheck;
  }
);

const isActive = withState("isActive", "setActive", ({ tax }) => {
  return tax.isActive;
});

const errors = withState("errors", "setErrors", {});

const handlers = withHandlers({
  validate: ({
    pourcentValue,
    label,
    onSubmit,
    errors,
    setErrors,
    isActive,
    id,
    defaultTaxCheck,
    mode,
    // codeDeclarationVente,
    // codeDeclarationAchat,
    // codeDeclarationImmo
  }) => () => {
    if ((pourcentValue >= 0) /*&& pourcentValue !== 0*/ && !!label) {
      return onSubmit(
        label,
        pourcentValue,
        isActive,
        id,
        defaultTaxCheck,
        mode,
        // codeDeclarationVente,
        // codeDeclarationAchat,
        // codeDeclarationImmo
      );
    }
    return setErrors({
      id: !id,
      pourcentValue: !pourcentValue,
      isActive: !isActive,
      label: !label,
      mode: !mode
    });
  }
});

const TaxSideModalForm = ({
  title,
  sideModalVisible,
  setSideModalVisible,
  label,
  pourcentValue,
  setLabel,
  setPourcentValue,
  isActive,
  setActive,
  mode,
  setMode,
  // codeDeclarationVente,
  // setCodeDeclarationVente,
  // codeDeclarationAchat,
  // setCodeDeclarationAchat,
  // codeDeclarationImmo,
  // setCodeDeclarationImmo,
  id,
  setId,
  defaultTaxCheck,
  setDefaultTaxCheck,
  validate,
  errors,
  options,
  showDefaultCheckBox = true,
  hideMode = false,
  disableDefaultTax
}) => {
  console.log("isActive", isActive);
  console.log("errors", errors);
  console.log("options", options);
  // console.log("codeDeclarationVente", codeDeclarationVente);

  const optionNames = _.uniqBy(
    options.map(option => {
      return { name: option.element.label };
    }),
    "name"
  );
  return (
    <SideModal
      // width="medium-wide"
      title={title}
      visible={sideModalVisible}
      handleClose={() => setSideModalVisible(false)}>
      <Col xs={12}>
        <TaxLabelInput
          errors={errors}
          value={label}
          onChange={setLabel}
          options={optionNames}
        />
      </Col>
      <Col xs={6}>
        <FormGroup
          validationState={
            errors.pourcentValue &&
              (pourcentValue === null || pourcentValue === undefined || pourcentValue < 0)
              ? "error"
              : null
          }>
          <ControlLabel>
            <FormattedMessage
              id="ids_taux"
              description="register new tax rate label"
              defaultMessage="Taux"
            />
          </ControlLabel>
          <NumberFormat
            allowNegative={false}
            className="form-control"
            value={pourcentValue}
            decimalScale={2}
            displayType="input"
            fixedDecimalScale={true}
            decimalSeparator={"."}
            thousandSeparator={true}
            onChange={e => setPourcentValue(parseFloat(e.target.value))}
          />
          {errors.pourcentValue && (pourcentValue === null || pourcentValue === undefined || pourcentValue < 0) && (
            <HelpBlock>
              <FormattedMessage id="ids_enterARate" />
            </HelpBlock>
          )}
        </FormGroup>
      </Col>
      <Col xs={6}>
        <h5 style={{ marginTop: "50px" }}>%</h5>
      </Col>

      <Col xs={12}>
        <FormGroup>
          <ControlLabel>
            <FormattedMessage id="ids_status" />
          </ControlLabel>
        </FormGroup>
        <Row style={{ alignContent: "center" }}>
          <Col xs={6}>
            <Switch
              onText=""
              offText=""
              value={isActive}
              onChange={() => setActive(!isActive)}
            />
          </Col>
          <Col xs={6}>
            <h6
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                float: "none"
              }}>
              {isActive ? "ACTIVE" : "INACTIVE"}
            </h6>
          </Col>
        </Row>
      </Col>
      {!hideMode && (
        <Col xs={12}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_declaration" />
            </ControlLabel>
          </FormGroup>
          <Row style={{ alignContent: "center" }}>
            <Col xs={12}>
              <CustomRadio
                number="1"
                option={"YES"}
                name="ENCAISSEMENT"
                disabled={false}
                checked={mode === "ENCAISSEMENT"}
                onChange={e => {
                  setMode(e.target.name);
                }}
                //                  checked={this.state.}
                label={<FormattedMessage id="ids_encaissement" />}
              />
              <CustomRadio
                number="2"
                option={"YES"}
                name="DEBIT"
                disabled={false}
                checked={mode === "DEBIT"}
                onChange={e => setMode(e.target.name)}
                //                  checked={this.state.}
                label={<FormattedMessage id="ids_debit" />}
              />
              <CustomRadio
                number="3"
                option={"YES"}
                name="NONE"
                disabled={false}
                checked={mode === "NONE"}
                onChange={e => setMode(e.target.name)}
                //                  checked={this.state.}
                label={<FormattedMessage id="ids_none" />}
              />
            </Col>
          </Row>
        </Col>
      )}

      {/* {!hideMode && (
        <Col xs={12}>
          <FormattedMessage id="ids_dclVente">
            {placeholder => (
              <FormGroup>
                <ControlLabel>{placeholder}</ControlLabel>
                <FormControl
                  type="text"
                  name="login"
                  value={codeDeclarationVente}
                  placeholder={codeDeclarationVente}
                  onChange={e => setCodeDeclarationVente(
                    e.target.value)
                  }
                />
              </FormGroup>
            )}
          </FormattedMessage>

          <FormattedMessage id="ids_dclAchat">
            {placeholder => (
              <FormGroup>
                <ControlLabel>{placeholder}</ControlLabel>
                <FormControl
                  type="text"
                  name="login"
                  value={codeDeclarationAchat}
                  placeholder={codeDeclarationAchat}
                  onChange={e => setCodeDeclarationAchat(
                    e.target.value)
                  }
                />
              </FormGroup>
            )}
          </FormattedMessage>

          <FormattedMessage id="ids_dclImmo">
            {placeholder => (
              <FormGroup>
                <ControlLabel>{placeholder}</ControlLabel>
                <FormControl
                  type="text"
                  name="login"
                  value={codeDeclarationImmo}
                  placeholder={codeDeclarationImmo}
                  onChange={e => setCodeDeclarationImmo(
                    e.target.value)
                  }
                />
              </FormGroup>
            )}
          </FormattedMessage>
        </Col>
      )} */}

      {showDefaultCheckBox && (
        <Col xs={12}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_taxByDefaultLabel" />
            </ControlLabel>
          </FormGroup>
          <Checkbox
            number="4"
            disabled={disableDefaultTax}
            isChecked={defaultTaxCheck}
            label={<FormattedMessage id="ids_setDefaultTax" />}
            onCheck={() => {
              console.log("oncheck");
              setDefaultTaxCheck(!defaultTaxCheck);
            }}
          />
        </Col>
      )}

      <Col xs={12}>
        <SaveButton block fill onClick={validate} />
      </Col>
    </SideModal>
  );
};

export default compose(
  label,
  mode,
  pourcentValue,
  // codeDeclarationVente,
  // codeDeclarationAchat,
  // codeDeclarationImmo,
  isActive,
  id,
  defaultTaxCheck,
  errors,
  handlers,
  pure
)(TaxSideModalForm);
